import React from 'react';
import { ShieldCheckIcon, CodeBracketIcon, CpuChipIcon } from '@heroicons/react/24/outline';
export function Hero() {
  return <section className="w-full bg-gradient-to-br from-blue-50 to-indigo-100 py-20 px-6" data-id="element-50">
      <div className="max-w-6xl mx-auto" data-id="element-51">
        <div className="text-center mb-12" data-id="element-52">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6" data-id="element-53">
            Welcome to SoftwarePair.com
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed" data-id="element-54">
            Your trusted source for insights, comparisons, and practical guides
            on software, cybersecurity, and digital technology.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mt-16" data-id="element-55">
          <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-56">
            <ShieldCheckIcon className="w-12 h-12 text-blue-600 mx-auto mb-4" data-id="element-57" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-58">
              Cybersecurity
            </h3>
            <p className="text-gray-600" data-id="element-59">
              Expert guidance on protecting your digital life
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-60">
            <CodeBracketIcon className="w-12 h-12 text-blue-600 mx-auto mb-4" data-id="element-61" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-62">
              Software Reviews
            </h3>
            <p className="text-gray-600" data-id="element-63">
              Honest comparisons to help you choose wisely
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-64">
            <CpuChipIcon className="w-12 h-12 text-blue-600 mx-auto mb-4" data-id="element-65" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-66">
              Tech Insights
            </h3>
            <p className="text-gray-600" data-id="element-67">
              Breaking down complex technology into simple terms
            </p>
          </div>
        </div>
      </div>
    </section>;
}